export { default } from './WheelchairIcon';
